import loadingCompass from '../../flight_select/assets/loading/loading-compass.webp';
import loadingCoconutDrink from '../../flight_select/assets/loading/loading-coconut-drink.webp';
import loadingPassport from '../../flight_select/assets/loading/loading-passport.webp';
import loadingAirplaneTicket from '../../flight_select/assets/loading/loading-airplane-ticket.webp';
import loadingHotAirBalloon from '../../flight_select/assets/loading/loading-hot-air-balloon.webp';
import loadingCamperVan from '../../flight_select/assets/loading/loading-camper-van.webp';

/** Hotel carousel images — replace with hotel-specific assets or API data later. */
export const LOADING_IMAGES = [
  loadingCompass,
  loadingCoconutDrink,
  loadingPassport,
  loadingAirplaneTicket,
  loadingHotAirBalloon,
  loadingCamperVan,
];

/** Hotel loading messages — shown in HotelLoader and hotel search screens. */
export const LOADING_MESSAGES = [
  'Great Wall isn\u2019t visible from the Moon.',
  'Sahara can get snow occasionally.',
  'Great Barrier Reef is the largest living structure.',
  'Changi Airport has a waterfall inside.',
  'Norway experiences midnight sun.',
  'Varanasi is one of the oldest living cities.',
  'Kerala backwaters are best viewed by houseboats.',
];
